import { jsx as c } from "react/jsx-runtime";
import { useSensors as i, useSensor as o, PointerSensor as l, TouchSensor as T, KeyboardSensor as C, DndContext as A, closestCenter as m, DragOverlay as O } from "@dnd-kit/core";
import { DragOverlay as R, useDraggable as V, useDroppable as G } from "@dnd-kit/core";
import { restrictToVerticalAxis as S, restrictToFirstScrollableAncestor as b } from "@dnd-kit/modifiers";
import { sortableKeyboardCoordinates as d } from "@dnd-kit/sortable";
import { CSS as K } from "@dnd-kit/utilities";
const p = 8, D = 250, y = 5, I = ({
  sensors: r = [],
  collisionDetection: t = m,
  modifiers: e = [S, b],
  accessibility: s,
  ...n
}) => {
  const a = i(
    o(l, {
      activationConstraint: { distance: p }
    }),
    o(T, {
      activationConstraint: {
        delay: D,
        tolerance: y
      }
    }),
    o(C, {
      coordinateGetter: d
    }),
    ...r
  );
  return /* @__PURE__ */ c(
    A,
    {
      sensors: a,
      collisionDetection: t,
      modifiers: e,
      accessibility: {
        container: document.body,
        ...s
      },
      ...n
    }
  );
}, g = I, x = O;
export {
  K as CSS,
  R as DragOverlay,
  I as Draggable,
  x as Overlay,
  g as Root,
  V as useDraggable,
  G as useDroppable
};
